export default __webpack_public_path__ + "static/media/students.5cb0f69c.svg";